import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { Grid } from '../../../core/components/grid/Grid.js';
import { isBandScale } from '../../../core/utils/detect-scale.js';
import { useAxesTicks } from '../../hooks/useAxesTicks.js';
import { useBarData } from '../../hooks/useBarData.js';
import { useGetVisibleAxesScales } from '../../hooks/useGetVisibleAxesScales.js';
import { useShouldShowGrid } from '../../hooks/useShouldShowGrid.js';

export const XYChartGridLayout = () => {
  const { width, height } = useGridPlotSize();

  const { shouldShowGrid } = useShouldShowGrid();
  const visibleAxisScales = useGetVisibleAxesScales();
  const { topTicks, bottomTicks, leftTicks, rightTicks } = useAxesTicks();
  const { hasXGroups, hasYGroups } = useBarData();

  if (!shouldShowGrid()) {
    return null;
  }

  if (!visibleAxisScales.hasXAndYScale) {
    return null;
  }

  const xTicks = bottomTicks.numericTicks ?? topTicks.numericTicks;
  const yTicks = leftTicks.numericTicks ?? rightTicks.numericTicks;

  const xCategoryOffset =
    hasXGroups && isBandScale(visibleAxisScales.xScale)
      ? visibleAxisScales.xScale.step() / 2
      : undefined;

  const yCategoryOffset =
    hasYGroups && isBandScale(visibleAxisScales.yScale)
      ? visibleAxisScales.yScale.step() / 2
      : undefined;

  return (
    <svg className={plotLayout}>
      <Grid
        xScale={visibleAxisScales.xScale}
        yScale={visibleAxisScales.yScale}
        height={height}
        width={width}
        xTicks={xTicks}
        yTicks={yTicks}
        highlightZeroLine={{
          horizontal: false,
          vertical: false,
        }}
        xCategoryOffset={xCategoryOffset}
        yCategoryOffset={yCategoryOffset}
      />
    </svg>
  );
};

XYChartGridLayout['displayName'] = 'XYChartGridLayout';
